import { useState, useEffect } from 'react';

export function useTargetBlockSize(targetRef) {
  const [targetWidth, setTargetWidth] = useState(0);

  const debounce = (func, timeout = 300) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  };

  const renewWidth = () => {
    if (targetRef?.current) {
      setTargetWidth(targetRef.current.offsetWidth);
    }
  };

  const updateDimensions = debounce(() => {
    renewWidth();
  }, 50);

  useEffect(() => {
    renewWidth();
  }, [targetRef?.current]);

  useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    updateDimensions();
    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  return { targetWidth };
}
